import LeftSideBar from "./LeftSideBar";
import PageContent from "./PageContent";
import ScrollToTop from "../middlewares/ScrollToTop";

function Layout() {
  return (
    <>
      <ScrollToTop />
      <div className="flex">
        <LeftSideBar />
        <PageContent />
      </div>
    </>
  );
}

export default Layout;
